export default {
  labels: {
    today: 'Astăzi',
    pickup_time: 'Ora de ridicare',
    on_site_time: 'Ora servirii',
    delivery_time: 'Ora de livrare',
  },
};
